import { NgModule } from '@angular/core';
import { ThemeModule } from '@app/@theme/theme.module';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './pages';
import { AuthRoutingModule } from './auth-routing.module';
import { ChangePasswordComponent } from './containers/change-password/change-password.component';
import { ChangePasswordFormComponent } from './components';
import { ChangePasswordPageComponent } from './pages/change-password-page';
import { CoreUIModule } from '@app/@core-ui';

@NgModule({
    imports: [ThemeModule, CoreUIModule, AuthRoutingModule],
    declarations: [LoginComponent, AuthComponent, ChangePasswordComponent, ChangePasswordFormComponent, ChangePasswordPageComponent],
    exports: [ChangePasswordComponent]
})
export class AuthModule {}
